import './App.css';
import myimg from './img/me.jpg';
import hkmt from './img/HongKongMassage.PNG';
import gym from './img/Gym.PNG';
import dax from './img/Car.PNG';
import invent from './img/invent.PNG';
import expense from './img/Expense.PNG';
import React, { useRef } from 'react';
import { Typewriter, Cursor } from 'react-simple-typewriter';
import emailjs from '@emailjs/browser';
import { FaLinkedin, FaGithub } from 'react-icons/fa';

function App() {
  const REACT_APP_PUBLIC_KEY = process.env.REACT_APP_PUBLIC_KEY;
  const REACT_APP_SERVICE_ID = process.env.REACT_APP_SERVICE_ID;
  const REACT_APP_TEMPLATE_ID = process.env.REACT_APP_TEMPLATE_ID;
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    emailjs.sendForm(REACT_APP_SERVICE_ID, REACT_APP_TEMPLATE_ID, form.current, REACT_APP_PUBLIC_KEY)
      .then(() => {
        document.getElementById("submitbutton").value = "Message Sent";
        document.getElementById("contact-form").reset();
      }, (error) => {
        document.getElementById("submitbutton").value = "Message Did Not Send"
        console.log(error.text);
      });

  };


  return (
    <div id='App'>
      <nav>
        <ul id='navbar'>
          <li><a href="#home">Home</a></li>
          <li><a href="#myabout">About</a></li>
          <li><a href="#webportfolio">Portfolio</a></li>
          <li><a href="#contactme">Contact</a></li>
        </ul>
      </nav>


      <div id="home">
        <div id='hellointro'>
          <p>Hello, my name is</p>
          <h1>
            Damon Morgan
          </h1>
          <p>
            I'm a&nbsp;
            <span>
              <Typewriter
                words={['Web Developer']}
                typeSpeed={100} />
            </span>
          </p>
        </div>
        <div id='frontbuttons'>
          <a href="/Damon2025Resume.pdf"><button type="button">Download Resume</button></a>
          <a href="#contactme"><button type="button">Contact</button></a>
        </div>
      </div>



      <div id='myabout'>
        <div id='aboutbg'>
          <h2 id='myaboutme'>About Me</h2>
          <div id='about-columns'>
            <div id='mypicture'>
              <img src={myimg} alt="Selfie" />
            </div>
            <p>
              <h3 id='skills'>
                Skills Include: &nbsp;
                <Typewriter
                  words={['HTML', 'CSS', 'JavaScript', 'SQL', 'PHP', 'Java', 'DevOps', 'TCP/IP Networking', 'Network Security', 'IT Support']}
                  typeSpeed={90}
                  loop={true} />
                <Cursor />
              </h3>
              <br></br>
              My interest for computers started at a young age, as of 13 I was able to deploy my first MyBB forum on a shared hosting plan. Shortly after, I began helping family with updating their websites and quickly picked up my first development language of HTML and CSS.
              <br></br>
              <br></br>
              I enjoy spending time with my family and participating in outdoor activities such as hiking, walking and various sports.
              <br></br>
              <br></br>
              I am eager to learn new skills, and I am passionate about exploring new technologies. I enjoy taking on challenging projects to push the boundaries of my abilities. From concept to deployment, my focus is on delivering exceptional results while following best practices.
            </p>
          </div>
        </div>
      </div>

      <div id="bghome"></div>

      <div id='webportfolio'>
        <div id='webportfoliobg'>
          <h2 id='port'>Portfolio</h2>
          <h3 id='webporttitle'>
            Check Out My Web Design
          </h3>
          <div className='card-container-one'>
            <div className='large-card'>
              <a href='https://gym.damonmorgan.net/'><img id='gym' src={gym} alt="Gym Website" /></a>
            </div>
            <div className='large-card'>
              <a href='https://daxmedia.damonmorgan.net'><img id='dax' src={dax} alt="Dax Media Website" /></a>
            </div>
            <div className='large-card'>
              <a href='https://hongkongmassagetherapyclinic.com'><img id='hkmt' src={hkmt} alt="HK Website" /></a>
            </div>
          </div>
        </div>
      </div>

      <div id='portfolio'>
        <div id='portfoliobg'>
          <h3 id='porttitle'>
            Check Out My Web Development
          </h3>
          <div className='card-container-one'>
            <div className='large-card'>
              <a href='https://inventory.damonmorgan.net/login.php'><img id='invent' src={invent} alt="Inventory Management System" /></a>
            </div>
            <div className='large-card'>
              <a href='https://expense.damonmorgan.net/'><img id='expense' src={expense} alt="Expenses Tracker" /></a>
            </div>
            <div className='large-card'>
              <p>
                Coming Soon
              </p>
              <p> Online ECommerce Store
              </p>
            </div>
          </div>
        </div>
      </div>

      <div id='contactme'>
        <h2 id='contactheader'>Contact Me</h2>
        <div id='ContactForm'>
          <form ref={form} id='contact-form' onSubmit={sendEmail}>
            <label for="firstname">First Name</label>
            <input type="text" id="firstname" name="firstname" placeholder="First name" required />

            <label for="lastname">Last Name</label>
            <input type="text" id="lastname" name="lastname" placeholder="Last name" />

            <label for="email">E-mail</label>
            <input type="email" id="email" name="email" placeholder="Email address" required />

            <label for="message">Message</label>
            <textarea id="message" name="message" placeholder="Type a message" required></textarea>

            <input type="submit" id='submitbutton' value="Send" />
          </form>
        </div>
      </div>
      <div className='foot'>
        <p>Damon Morgan © 2025</p>
        <p><a href="https://www.linkedin.com/in/damon-morgan/"><FaLinkedin size={30} color="#0A66C2" /></a> <a href="https://github.com/damon-morgan"><FaGithub size={30} color='white' /></a></p>
      </div>
    </div>

  );

};
export default App;